import {
  STORE_TERMS,
  UPDATE_T_AND_C,
  TERMS_ACCEPTED,
} from "../Legal/sections/terms-and-conditions/constants"

import {
  STORE_USER_SESSION,
  SIGN_USER_OUT,
  STORE_USER_POOL,
  STORE_MODULES,
  REPLACE_PERMISSIONS,
  STORE_SETTINGS,
  STORE_MODULE_DATA,
  STORE_PASSWORD_CRITERIA,
  RENDER_APPLICATION,
  STORE_AVAILABLE_MODULES,
  STORE_SESSION_TIMER,
  STORE_SESSION_TIMER_INFO,
  DELETE_SESSION_TIMER,
  SET_ENTITY,
  SET_ENTITIES,
  SET_PROTOCOLS,
  SET_SSO_ENABLED,
  SET_USER_DETAILS,
} from "./constants"

export const initialState = {
  protocols: null,
  loggedIn: null,
  session: null,
  userPool: null,
  signOut: null,
  refreshToken: null,
  idTokenPayload: {
    given_name: "-",
    family_name: "-",
  },
  modules: {},
  settings: {
    homepage: null,
  },
  features: [],
  tools: [],
  permissions: {},
  availableModules: null,
  tc: null,
  tcManager: null,
  tcTerms: null,
  moduleData: [],
  adminOnly: null,
  render: true,
  passwordCriteria: null,
  sessionTimer: null,
  sessionExpiryTime: null,
  applicationClientId: null,
  userPoolId: null,
  entity: "",
  entities: [],
  ssoEnabled: null,
  userDetails: null,
}

// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => {
  const newState = { ...state }
  switch (action.type) {
    case REPLACE_PERMISSIONS:
      newState.permissions = action.permissions
      break
    case SET_SSO_ENABLED:
      newState.ssoEnabled = action.ssoEnabled
      break
    case STORE_SESSION_TIMER:
      newState.sessionTimer = action.sessionTimer
      newState.render = true
      newState.loggedIn = true
      break
    case DELETE_SESSION_TIMER:
      newState.sessionTimer = null
      break
    case SET_PROTOCOLS:
      newState.protocols = action.protocols
      newState.ssoEnabled = action.ssoEnabled
      break
    case STORE_SESSION_TIMER_INFO:
      newState.sessionExpiryTime = action.sessionExpiryTime
      break
    case STORE_USER_SESSION:
      newState.loggedIn = true
      newState.session = action.session
      newState.userPool = action.userPool
      newState.signOut = action.signOut
      newState.refreshToken = action.refreshToken
      newState.idTokenPayload = action.idTokenPayload
      break
    case STORE_MODULE_DATA:
      newState.moduleData = action.moduleData
      break
    case STORE_MODULES:
      newState.tools = action.tools
      newState.features = action.features
      break
    case SIGN_USER_OUT:
      newState.loggedIn = false
      newState.session = null
      newState.signOut = null
      newState.refreshToken = null
      newState.idTokenPayload = {}
      newState.modules = {}
      newState.features = []
      newState.tools = []
      newState.tc = null
      newState.sessionTimer = null
      newState.sessionExpiryTime = null
      newState.render = true
      break
    case STORE_USER_POOL:
      newState.loggedIn = action.loggedOut === true ? false : newState.loggedIn
      newState.userPool = action.userPool
      newState.applicationClientId = action.userPool.clientId
      newState.userPoolId = action.userPool.userPoolId
      break
    case STORE_SETTINGS:
      newState.settings = action.settings
      break
    case STORE_AVAILABLE_MODULES:
      newState.availableModules = action.availableModules
      newState.availableModulesData = action.availableModulesData
      break
    case UPDATE_T_AND_C:
      newState.tcManager = action.tcManager
      break
    case STORE_TERMS:
      newState.tcTerms = action.tcTerms
      break
    case TERMS_ACCEPTED:
      newState.tc = {
        ...newState.tc,
        outstanding: newState.tc?.outstanding.filter(
          ([el]) => el !== action.module
        ),
        outstandingApplications: newState.tc?.outstandingApplications.filter(
          ([application]) => application !== action.module
        ),
      }
      break
    case STORE_PASSWORD_CRITERIA:
      newState.passwordCriteria = action.passwordCriteria
      newState.adminOnly = action.adminOnly
      break
    case RENDER_APPLICATION:
      newState.render = action.render
      break
    case SET_ENTITY:
      newState.entity_id = action.entity_id
      break
    case SET_ENTITIES:
      newState.entities = action.entities
      break
    case SET_USER_DETAILS:
      newState.userDetails = {
        ...newState.userDetails,
        ...action.userDetails,
      }
      break
    default:
      return state
  }

  return newState
}
export default reducer
